import type { enPlatform } from '../en/platform';

export const idPlatform: Record<keyof typeof enPlatform, string> = {
  'platform.name': 'Konsol platform',
  'platform.role.owner': 'Pemilik platform',
  'platform.role.operator': 'Operator',
  'platform.role.support': 'Dukungan',
  'platform.roleHint.owner': 'Semua akses, termasuk paket, pengaturan, dan admin.',
  'platform.roleHint.operator':
    'Membuat tenant, menangguhkan, mengaktifkan kembali, memperpanjang uji coba, mengganti paket.',
  'platform.roleHint.support': 'Melihat tenant dan meminta akses dukungan; tanpa perubahan.',
  'platform.nav.tenants': 'Tenant',
  'platform.nav.plans': 'Paket',
  'platform.nav.audit': 'Log audit',
  'platform.nav.settings': 'Pengaturan',
  'platform.nav.admins': 'Admin',
  'platform.ownerOnly': 'Hanya pemilik platform yang dapat membuka halaman ini.',

  'platform.status.trialing': 'Uji coba',
  'platform.status.active': 'Aktif',
  'platform.status.past_due': 'Jatuh tempo',
  'platform.status.read_only': 'Hanya baca',
  'platform.status.suspended': 'Ditangguhkan',
  'platform.status.cancelled': 'Dibatalkan',
  'platform.membership.invited': 'Diundang',
  'platform.membership.active': 'Aktif',
  'platform.membership.deactivated': 'Nonaktif',

  // ---- Daftar tenant -----------------------------------------------------------------------
  'platform.tenants.title': 'Tenant',
  'platform.tenants.subtitle':
    'Semua restoran di platform beserta paket, status, dan pemakaiannya.',
  'platform.tenants.create': 'Buat tenant',
  'platform.tenants.col.name': 'Tenant',
  'platform.tenants.col.plan': 'Paket',
  'platform.tenants.col.status': 'Status',
  'platform.tenants.col.branches': 'Cabang',
  'platform.tenants.col.staff': 'Staf',
  'platform.tenants.col.devices': 'Perangkat',
  'platform.tenants.col.trialEnds': 'Uji coba berakhir',
  'platform.tenants.col.lastActivity': 'Aktivitas terakhir',
  'platform.tenants.allPlans': 'Semua paket',
  'platform.tenants.allStatuses': 'Semua status',
  'platform.tenants.search': 'Nama, slug, atau e-mail penagihan',
  'platform.tenants.empty': 'Belum ada tenant — buat yang pertama untuk mendaftarkan restoran.',
  'platform.tenants.back': 'Semua tenant',

  // ---- Buat tenant -------------------------------------------------------------------------
  'platform.create.title': 'Buat tenant',
  'platform.create.description':
    'Menyiapkan restoran, cabang pertama, dan stasiun dapurnya, lalu mengundang pemilik.',
  'platform.create.section.tenant': 'Restoran',
  'platform.create.section.owner': 'Pemilik',
  'platform.create.section.branch': 'Cabang pertama',
  'platform.create.name': 'Nama restoran',
  'platform.create.slug': 'Slug',
  'platform.create.slugHint':
    'Huruf kecil, angka, dan tanda hubung (3–40). Tidak dapat diubah nanti.',
  'platform.create.legalName': 'Nama badan usaha',
  'platform.create.billingEmail': 'E-mail penagihan',
  'platform.create.plan': 'Paket',
  'platform.create.planPick': 'Pilih paket',
  'platform.create.trialDays': 'Hari uji coba',
  'platform.create.trialDaysHint': '0 berarti langganan langsung berjalan (maks. 90).',
  'platform.create.ownerEmail': 'E-mail pemilik',
  'platform.create.ownerName': 'Nama pemilik',
  'platform.create.ownerLocale': 'Bahasa pemilik',
  'platform.create.branchCode': 'Kode cabang',
  'platform.create.branchName': 'Nama cabang',
  'platform.create.submit': 'Buat tenant',
  'platform.create.error.name': 'Masukkan nama restoran.',
  'platform.create.error.slug': 'Gunakan 3–40 huruf kecil, angka, atau tanda hubung.',
  'platform.create.error.slugTaken': 'Slug ini sudah dipakai.',
  'platform.create.error.email': 'Masukkan alamat e-mail yang valid.',
  'platform.create.error.plan': 'Pilih paket.',
  'platform.create.error.trialDays': 'Masukkan 0 sampai 90 hari.',
  'platform.create.error.ownerName': 'Masukkan nama pemilik.',
  'platform.create.created': '{name} berhasil dibuat.',
  'platform.create.doneText':
    '{name} sudah siap. Kirimkan tautan undangan ke pemilik agar ia dapat membuat kata sandi.',
  'platform.create.inviteLink': 'Tautan undangan',
  'platform.create.copy': 'Salin',
  'platform.create.copied': 'Tautan undangan disalin.',
  'platform.create.copyFailed': 'Gagal menyalin — pilih tautannya lalu salin secara manual.',
  'platform.create.inviteOnce': 'Tautan ini hanya ditampilkan sekali dan berlaku 7 hari.',
  'platform.create.existingOwner':
    'Pemilik sudah punya akun dan dapat masuk dengan akun tersebut untuk membuka restoran barunya.',
  'platform.create.openTenant': 'Buka tenant',
  'platform.create.done': 'Selesai',

  // ---- Detail tenant -----------------------------------------------------------------------
  'platform.detail.subtitle': '{slug} · {email}',
  'platform.detail.subscription': 'Langganan',
  'platform.detail.subscriptionDesc':
    'Paket dan siklus langganan. Setiap perubahan tercatat di kedua log audit.',
  'platform.detail.periodEnd': 'Periode berakhir',
  'platform.detail.created': 'Dibuat',
  'platform.detail.company': 'Perusahaan dan pemakaian',
  'platform.detail.companyDesc': 'Data penagihan dan apa yang dipakai tenant saat ini.',
  'platform.detail.taxId': 'NPWP',
  'platform.detail.branches': 'Cabang',
  'platform.detail.branchesDesc': 'Hanya nama, kode, dan status — tanpa data bisnis.',
  'platform.detail.noBranches': 'Belum ada cabang.',
  'platform.detail.owners': 'Pemilik',
  'platform.detail.ownersDesc': 'Orang dengan peran pemilik dan status akunnya.',
  'platform.detail.noOwners': 'Belum ada pemilik.',
  'platform.detail.audit': 'Audit platform',
  'platform.detail.auditDesc': 'Tindakan platform terbaru untuk tenant ini.',
  'platform.detail.auditAll': 'Log audit lengkap',

  // ---- Tindakan siklus ---------------------------------------------------------------------
  'platform.actions.suspend': 'Tangguhkan',
  'platform.actions.reactivate': 'Aktifkan kembali',
  'platform.actions.extendTrial': 'Perpanjang uji coba',
  'platform.actions.changePlan': 'Ganti paket',
  'platform.actions.grantLicence': 'Lisensi gratis',
  'platform.actions.editLicence': 'Ubah lisensi gratis',
  'platform.actions.revokeLicence': 'Cabut lisensi gratis',
  'platform.actions.licence.title': 'Lisensi gratis',
  'platform.actions.licence.body':
    '{name} mendapat paket yang dipilih secara gratis — untuk restoran Anda sendiri atau rekan. Tanpa tagihan, pengingat, atau batas pembayaran; akun tetap aktif sampai Anda mencabutnya.',
  'platform.actions.licence.plan': 'Paket',
  'platform.actions.licence.planHint': 'Menentukan modul dan batas.',
  'platform.actions.licence.note': 'Catatan',
  'platform.actions.licence.noteHint': 'Untuk siapa dan alasannya, mis. “Restoran sendiri”.',
  'platform.actions.licence.done': '{name} mendapat lisensi gratis.',
  'platform.actions.revokeLicence.title': 'Cabut lisensi gratis',
  'platform.actions.revokeLicence.body':
    '{name} tetap aktif dengan paketnya, tetapi tidak lagi gratis: terbitkan tagihan untuk mulai menagih.',
  'platform.actions.revokeLicence.done': 'Lisensi gratis {name} telah dicabut.',
  'platform.licence.badge': 'Gratis',
  'platform.actions.working': 'Memproses…',
  'platform.actions.reason': 'Alasan',
  'platform.actions.reasonRequired': 'Masukkan alasan (minimal 3 karakter).',
  'platform.actions.conflict':
    'Tenant ini baru saja berubah atau statusnya tidak memungkinkan tindakan ini. Muat ulang lalu coba lagi.',
  'platform.actions.suspend.title': 'Tangguhkan tenant',
  'platform.actions.suspend.body':
    'Staf {name} akan dikeluarkan dan tidak dapat bekerja sampai tenant diaktifkan kembali. Pemilik tetap dapat masuk, melihat langganan, dan mengekspor datanya.',
  'platform.actions.suspend.hint': 'Ditampilkan di log audit tenant.',
  'platform.actions.suspend.done': '{name} ditangguhkan.',
  'platform.actions.reactivate.title': 'Aktifkan kembali tenant',
  'platform.actions.reactivate.body':
    '{name} dapat langsung bekerja lagi. Uji coba yang belum berakhir akan berlanjut.',
  'platform.actions.reactivate.done': '{name} aktif kembali.',
  'platform.actions.extend.title': 'Perpanjang uji coba',
  'platform.actions.extend.body': 'Uji coba {name} saat ini berakhir pada {date}.',
  'platform.actions.extend.bodyNoTrial':
    '{name} belum punya tanggal akhir uji coba; uji coba dimulai hari ini.',
  'platform.actions.extend.days': 'Tambahan hari',
  'platform.actions.extend.hint':
    '1 sampai 60 hari, ditambahkan ke tanggal akhir saat ini (atau ke hari ini jika sudah lewat).',
  'platform.actions.extend.daysError': 'Masukkan 1 sampai 60 hari.',
  'platform.actions.extend.done': 'Uji coba {name} diperpanjang.',
  'platform.actions.plan.title': 'Ganti paket',
  'platform.actions.plan.body':
    '{name} memakai paket {plan}. Modul dan batasnya langsung berubah untuk semua staf.',
  'platform.actions.plan.label': 'Paket baru',
  'platform.actions.plan.hint': 'Hanya paket aktif yang dapat dipilih.',
  'platform.actions.plan.done': 'Paket {name} sudah diganti.',

  // ---- Akses dukungan (sisi platform) ------------------------------------------------------
  'platform.support.title': 'Akses dukungan',
  'platform.support.description':
    'Tampilan hanya-baca atas tenant ini selama 1–24 jam, hanya setelah pemilik menyetujui. Setiap akses tercatat.',
  'platform.support.reason': 'Alasan untuk pemilik',
  'platform.support.reasonHint': 'Pemilik membaca teks ini sebelum memutuskan.',
  'platform.support.reasonError': 'Jelaskan alasannya minimal 10 karakter.',
  'platform.support.hours': 'Lama akses',
  'platform.support.hoursOption': '{count} jam',
  'platform.support.request': 'Minta akses',
  'platform.support.requested': 'Permintaan terkirim. Pemilik memutuskannya di back office.',
  'platform.support.alreadyOpen':
    'Anda sudah punya permintaan yang menunggu atau masih aktif untuk tenant ini.',
  'platform.support.waiting': 'Permintaan Anda menunggu keputusan pemilik.',
  'platform.support.live': 'Pemilik menyetujui akses Anda sampai {time}.',
  'platform.support.openOverview': 'Buka ringkasan dukungan',
  'platform.support.none': 'Belum ada permintaan akses dukungan.',
  'platform.support.overview.title': 'Ringkasan dukungan',
  'platform.support.overview.description':
    'Aktivitas hari ini per cabang dan entri audit tenant terbaru. Tampilan ini tercatat.',
  'platform.support.overview.reload': 'Muat ulang',
  'platform.support.overview.generated': 'Diambil pada {time}.',
  'platform.support.overview.branch': 'Cabang',
  'platform.support.overview.ordersToday': 'Pesanan hari ini',
  'platform.support.overview.salesToday': 'Tagihan hari ini',
  'platform.support.overview.openOrders': 'Pesanan terbuka',
  'platform.support.overview.openTables': 'Meja terisi',
  'platform.support.overview.audit': 'Entri audit tenant terbaru',

  // ---- Paket -------------------------------------------------------------------------------
  'platform.plans.title': 'Paket',
  'platform.plans.subtitle':
    'Harga, batas, dan modul setiap paket. Perubahan berlaku untuk semua tenant di paket itu.',
  'platform.plans.readOnly': 'Hanya pemilik platform yang dapat mengubah paket.',
  'platform.plans.col.plan': 'Paket',
  'platform.plans.col.price': 'Harga',
  'platform.plans.col.modules': 'Modul',
  'platform.plans.col.state': 'Status',
  'platform.plans.limit.max_branches': 'Cabang',
  'platform.plans.limit.max_staff': 'Staf',
  'platform.plans.limit.max_devices': 'Perangkat',
  'platform.plans.limitHint': 'Kosong = tanpa batas.',
  'platform.plans.unlimited': 'Tanpa batas',
  'platform.plans.internal': 'internal',
  'platform.plans.interval.month': 'per bulan',
  'platform.plans.interval.year': 'per tahun',
  'platform.plans.editNamed': 'Ubah {name}',
  'platform.plans.editTitle': 'Ubah paket {name}',
  'platform.plans.editDesc': 'Tenant di paket ini langsung mendapat modul dan batas yang baru.',
  'platform.plans.name': 'Nama',
  'platform.plans.price': 'Harga ({currency})',
  'platform.plans.public': 'Publik',
  'platform.plans.publicHint': 'Tampil di daftar harga; paket internal diberikan secara manual.',
  'platform.plans.active': 'Aktif',
  'platform.plans.activeHint': 'Paket nonaktif tidak dapat dipilih untuk tenant.',
  'platform.plans.saved': 'Paket {name} disimpan.',
  'platform.plans.conflict':
    'Paket ini baru saja diubah orang lain. Tutup dialog untuk memuat versi terbaru.',
  'platform.plans.error.name': 'Masukkan nama.',
  'platform.plans.error.price': 'Masukkan harga sebagai bilangan bulat.',
  'platform.plans.error.limit': 'Masukkan minimal 1, atau kosongkan untuk tanpa batas.',
  'platform.module.pos': 'Kasir (POS)',
  'platform.module.kds': 'Layar dapur',
  'platform.module.service': 'Layanan meja',
  'platform.module.guest_qr': 'Menu QR',
  'platform.module.guest_ordering': 'Pesan mandiri tamu',
  'platform.module.inventory': 'Inventaris',
  'platform.module.procurement': 'Pengadaan',
  'platform.module.ap': 'Utang usaha',
  'platform.module.approvals': 'Persetujuan',
  'platform.module.budgets': 'Anggaran',
  'platform.module.custom_domain': 'Domain sendiri',
  'platform.module.warehouse': 'Gudang',

  // ---- Pengaturan --------------------------------------------------------------------------
  'platform.settings.title': 'Pengaturan platform',
  'platform.settings.subtitle': 'Bawaan penagihan langganan dan dokumen hukum.',
  'platform.settings.billing': 'Penagihan',
  'platform.settings.billingDesc':
    'Pajak, jangka pembayaran, penagihan tunggakan, dan penerbit di faktur langganan.',
  'platform.settings.legal': 'Hukum',
  'platform.settings.legalDesc': 'Versi ketentuan yang disetujui pemilik dan tautan dokumennya.',
  'platform.settings.taxRate': 'Tarif PPN (%)',
  'platform.settings.taxRateHint': 'Maksimal dua desimal, mis. 11. Pastikan dicek konsultan pajak.',
  'platform.settings.payment_terms_days': 'Jangka pembayaran (hari)',
  'platform.settings.grace_days': 'Masa tenggang (hari)',
  'platform.settings.read_only_after_days': 'Hanya baca setelah (hari)',
  'platform.settings.trial_days': 'Uji coba bawaan (hari)',
  'platform.settings.issuer': 'Penerbit',
  'platform.settings.issuerName': 'Nama badan usaha',
  'platform.settings.issuerAddress': 'Alamat',
  'platform.settings.issuerTaxId': 'NPWP',
  'platform.settings.issuerBank': 'Rekening bank',
  'platform.settings.termsVersion': 'Versi ketentuan',
  'platform.settings.termsVersionHint': 'Huruf, angka, titik, dan tanda hubung, mis. 2026-10-11.',
  'platform.settings.termsUrl': 'URL ketentuan layanan',
  'platform.settings.privacyUrl': 'URL kebijakan privasi',
  'platform.settings.updatedAt': 'Terakhir disimpan {time}',
  'platform.settings.saved': 'Pengaturan disimpan.',
  'platform.settings.conflict':
    'Pengaturan ini baru saja disimpan orang lain. Muat ulang halaman untuk melihatnya.',
  'platform.settings.error.tax': 'Masukkan tarif 0 sampai 50 dengan maksimal dua desimal.',
  'platform.settings.error.days': 'Masukkan 0 sampai 90 hari.',
  'platform.settings.error.issuer': 'Masukkan nama badan usaha penerbit.',
  'platform.settings.error.version': 'Gunakan huruf, angka, titik, atau tanda hubung (maks. 40).',
  'platform.settings.error.url': 'Masukkan tautan lengkap yang diawali https://.',

  // ---- Admin -------------------------------------------------------------------------------
  'platform.admins.title': 'Admin platform',
  'platform.admins.subtitle':
    'Staf kami yang punya akses ke konsol ini. Bukan keanggotaan di tenant mana pun.',
  'platform.admins.col.person': 'Orang',
  'platform.admins.col.role': 'Peran',
  'platform.admins.col.since': 'Sejak',
  'platform.admins.you': '(Anda)',
  'platform.admins.add': 'Tambah admin',
  'platform.admins.addDesc': 'Orang tersebut harus sudah punya akun.',
  'platform.admins.email': 'E-mail',
  'platform.admins.emailHint': 'E-mail akunnya.',
  'platform.admins.addSubmit': 'Tambah admin',
  'platform.admins.added': '{name} sekarang menjadi admin platform.',
  'platform.admins.already': 'Orang ini sudah menjadi admin platform.',
  'platform.admins.noAccount': 'Tidak ada akun aktif dengan e-mail ini.',
  'platform.admins.removeNamed': 'Hapus {name}',
  'platform.admins.removeTitle': 'Hapus admin platform',
  'platform.admins.removeBody': '{name} langsung kehilangan akses ke konsol platform.',
  'platform.admins.removed': 'Admin platform dihapus.',
  'platform.admins.lastOwner':
    'Pemilik platform terakhir tidak dapat dihapus. Tambahkan pemilik lain terlebih dahulu.',

  // ---- Audit -------------------------------------------------------------------------------
  'platform.audit.title': 'Log audit platform',
  'platform.audit.subtitle': 'Setiap tindakan di konsol ini, dari yang terbaru.',
  'platform.audit.empty': 'Belum ada entri — tindakan langsung muncul di sini begitu terjadi.',
  'platform.audit.more': 'Muat lebih banyak',
  'platform.audit.col.time': 'Waktu',
  'platform.audit.col.action': 'Tindakan',
  'platform.audit.col.tenant': 'Tenant',
  'platform.audit.col.actor': 'Oleh',
  'platform.audit.col.details': 'Rincian',
  'platform.audit.action.tenant.provisioned': 'Tenant dibuat',
  'platform.audit.action.tenant.suspended': 'Tenant ditangguhkan',
  'platform.audit.action.tenant.reactivated': 'Tenant diaktifkan kembali',
  'platform.audit.action.tenant.trial_extended': 'Uji coba diperpanjang',
  'platform.audit.action.tenant.plan_changed': 'Paket diganti',
  'platform.audit.action.support_access.requested': 'Akses dukungan diminta',
  'platform.audit.action.support_access.approved': 'Akses dukungan disetujui',
  'platform.audit.action.support_access.rejected': 'Akses dukungan ditolak',
  'platform.audit.action.support_access.revoked': 'Akses dukungan dicabut',
  'platform.audit.action.support_access.viewed': 'Ringkasan dukungan dilihat',
  'platform.audit.action.plan.updated': 'Paket diubah',
  'platform.audit.action.platform_setting.updated': 'Pengaturan diubah',
  'platform.audit.action.platform_admin.added': 'Admin ditambahkan',
  'platform.audit.action.platform_admin.removed': 'Admin dihapus',

  // ---- Akses dukungan (sisi pemilik, back office) ------------------------------------------
  'bo.nav.supportAccess': 'Akses dukungan',
  'support.title': 'Akses dukungan',
  'support.subtitle':
    'Tim dukungan kami hanya dapat melihat data Anda dengan persetujuan Anda, untuk waktu terbatas. Setiap akses tercatat di log audit Anda.',
  'support.ownerOnly': 'Hanya pemilik yang dapat memutuskan akses dukungan.',
  'support.empty':
    'Belum ada permintaan — tim dukungan akan meminta di sini bila perlu memeriksa sesuatu.',
  'support.col.requested': 'Diminta',
  'support.col.by': 'Oleh',
  'support.col.reason': 'Alasan',
  'support.col.hours': 'Jam',
  'support.col.status': 'Status',
  'support.col.until': 'Sampai',
  'support.col.actions': 'Tindakan',
  'support.status.requested': 'Diminta',
  'support.status.approved': 'Disetujui',
  'support.status.rejected': 'Ditolak',
  'support.status.revoked': 'Dicabut',
  'support.status.expired': 'Kedaluwarsa',
  'support.approve': 'Setujui',
  'support.reject': 'Tolak',
  'support.revoke': 'Akhiri akses',
  'support.approve.title': 'Setujui akses dukungan',
  'support.approve.body':
    '{name} dapat melihat ringkasan hanya-baca restoran Anda selama {hours} jam, mulai sekarang. Anda dapat mengakhirinya kapan saja.',
  'support.approve.done': 'Akses dukungan disetujui.',
  'support.reject.title': 'Tolak akses dukungan',
  'support.reject.body': '{name} tidak mendapat akses. Ia dapat meminta lagi nanti.',
  'support.reject.done': 'Akses dukungan ditolak.',
  'support.revoke.title': 'Akhiri akses dukungan',
  'support.revoke.body': 'Akses untuk {name} langsung berakhir.',
  'support.revoke.done': 'Akses dukungan diakhiri.',
  'support.conflict': 'Permintaan ini sudah diputuskan atau sudah kedaluwarsa. Muat ulang halaman.',
};
